module.exports = __webpack_public_path__ + "img/mastercard.3bc1de3c.svg";